import React, { useState } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import confirm from 'react-confirm2';
import Button from '../../../../common/components/Button/Button';
import { actions as customerActions } from '../../redux/customerActions';
import CustomerMergeList from '../../components/CustomerMergeList/CustomerMergeList';
import InfoLabel from '../../../../common/components/InfoLabel/InfoLabel';
import { FormGroup, ControlLabel, Col, Row, Modal } from 'react-bootstrap';
import formatDate from '../../../../helpers/formatDate';
import './styles.scss';

const MergeCustomersButton = ({
  customer,
  customerId,
  onMergeCustomers,
  onRefresh,
  submitting,
}) => {
  const [open, setOpen] = useState(false);

  const mergeCustomer = (newCustomer) => {
    return Promise.resolve(onMergeCustomers(customerId, newCustomer)).then(() => {
      closeModel();
      onRefresh();
    });
  };

  const handleRowClick = (row) => {
    const formattedDOB = formatDate(row.dob);
    confirm('Warning', {
      description:
        'Are you sure you want to merge ' +
        row.customer_name +
        ' (' +
        formattedDOB +
        ') into ' +
        customer.customer_name +
        ' (' +
        customer.dob +
        ')? This action cannot be reversed.',
      done: () => {
        const newCustomer = {
          data: {
            relationships: {
              customer: {
                data: {
                  id: row.id,
                },
              },
            },
          },
        };
        mergeCustomer(newCustomer);
      },
    });
  };

  const openModel = () => {
    setOpen(true);
  };

  const closeModel = () => {
    setOpen(false);
  };

  const title = 'Merge Customers';

  return (
    <div>
      <Button
        bsStyle="primary"
        label={title}
        handleClick={openModel}
        className="pull-right pad-right"
      />

      <Modal bsSize={'lg'} show={open} onHide={closeModel}>
        <Modal.Header closeButton>{title}</Modal.Header>
        <>
          <Modal.Body>
            <div className="merge-customers">
              <FormGroup>
                <Col sm={12}>
                  <ControlLabel>
                    <h3 className="customer-title">Original Customer</h3>
                  </ControlLabel>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={6}>
                  <InfoLabel
                    label="Name"
                    value={
                      customer.title +
                      ' ' +
                      customer.first_name +
                      ' ' +
                      customer.last_name
                    }
                    labelSize={4}
                  />
                </Col>
                <Col sm={6}>
                  <InfoLabel label="Email" value={customer.email} labelSize={4} />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={12}>
                  {customer.company_name && (
                    <InfoLabel
                      label="Company Name"
                      value={customer.company_name}
                      labelSize={4}
                    />
                  )}
                </Col>
              </FormGroup>
              <FormGroup>
                <Col sm={6}>
                  <InfoLabel
                    label="Date of Birth"
                    value={customer.dob}
                    //date={true}
                    labelSize={4}
                  />
                </Col>
                <Col sm={6}>
                  <InfoLabel
                    label="Postcode"
                    value={get(customer, 'address.postcode', '')}
                    labelSize={4}
                  />
                </Col>
              </FormGroup>

              <Row>
                <Col sm={12}>
                  <CustomerMergeList
                    quoteHeader={'get-customer-header'}
                    showCreateCustomer={false}
                    internalContainer={false}
                    handleRowClick={handleRowClick}
                  />
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle={'default'}
              handleClick={closeModel}
              className={'pull-left'}
              disabled={submitting}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </>
      </Modal>
    </div>
  );
};

export default connect(
  null,
  {
    onMergeCustomers: customerActions.mergeCustomers,
  },
)(MergeCustomersButton);
